import { render, staticRenderFns } from "./SectionGalleries.vue?vue&type=template&id=4197147a&scoped=true&"
import script from "./SectionGalleries.vue?vue&type=script&lang=js&"
export * from "./SectionGalleries.vue?vue&type=script&lang=js&"
import style0 from "./SectionGalleries.vue?vue&type=style&index=0&id=4197147a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197147a",
  null
  
)

export default component.exports